import {getEnv} from '../../config/environment';
import {navigateWithAnalytics} from '@/utils/wrappers/Delta';

export default async function authenticatePinterest(
  userId: string | null,
  redirectQueryParams: Record<string, string> = {}
): Promise<void> {
  const authUrl = getPinterestAuthUrl(
    window.location,
    userId,
    redirectQueryParams
  );
  await navigateWithAnalytics(authUrl);
}

const getPinterestAuthUrl = (
  currentLocation: Location,
  userId: string | null,
  redirectQueryParams: Record<string, string>
): string => {
  const scope = 'user_accounts:read,pins:read,boards:read';
  const serverCallbackUri = encodeURIComponent(
    getEnv().PINTEREST_SERVER_CALLBACK_URI
  );
  const clientId = getEnv().PINTEREST_APP_ID_V3;
  const redirectUrlBase = `${getEnv().DOMAIN_HOST}${currentLocation.pathname}`;

  const currentQueryParams = currentLocation.search
    ? `${currentLocation.search.substring(1)}&`
    : '';

  const successRedirectUrl = encodeURIComponent(
    `${redirectUrlBase}/callback?${currentQueryParams}success=true&provider=pinterest&redirectPath=${currentLocation.pathname}`.replace(
      '//callback',
      '/callback'
    )
  );
  const queryChar = redirectUrlBase.includes('?') ? '&' : '?';
  const failureRedirectUrl = encodeURIComponent(
    `${redirectUrlBase}${queryChar}provider=pinterest`
  );

  const state = encodeURIComponent(
    JSON.stringify({
      success_redirect_url: successRedirectUrl,
      failure_redirect_url: failureRedirectUrl,
      user_id: userId,
    })
  );

  return `https://www.pinterest.com/oauth/?client_id=${clientId}&redirect_uri=${serverCallbackUri}&response_type=code&scope=${scope}&state=${state}`;
};
